// extracted by mini-css-extract-plugin
export default {"spinner":"loading_spinner__XlJGM","spin":"loading_spin__4+8gt","label":"loading_label__EgI88"};